export const useLocalStorage = () => {
	const prefix = '@WelbeCompany';

	const setLocalStorage = (key: string, value: string) => {
		localStorage.setItem(`${prefix}:${key}`, value);
	};

	const getLocalStorage = (key: string) => {
		return localStorage.getItem(`${prefix}:${key}`);
	};

	const removeKeyLocalStorage = (key: string) => {
		localStorage.removeItem(`${prefix}:${key}`);
	};

	const clearLocalStorage = () => {
		localStorage.clear();
	};

	return {
		setLocalStorage,
		getLocalStorage,
		removeKeyLocalStorage,
		clearLocalStorage,
	};
};
